import React from 'react';
import { TitleLink } from '~/src/components/Main/Info/ProductCard/styled';
import Link from 'next/link';

const TitleBlock = ({ route, name }) => {
    const WrapLink = ({ children }) => {
        return route ? <Link href={route} passHref={true}>{children}</Link> : <>{children}</>;
    };

    return (
        <WrapLink>
            <TitleLink title={name} data-test='router-item-link'>
                {name}
            </TitleLink>
        </WrapLink>
    );
};

export default TitleBlock;
